import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
    fontSizes,
    gutterSizes,
    colorVariables,
    colors,
    mediaQuery,
    breakpoints,
    fontWeights,
} from "@gumtree/ui-library/src/base/theme";

export const HeaderBlockContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const HeaderBlockInfo = styled.div<{
    isMobileCardsLayout: boolean;
    showCarMoneyMonthlyPrice: boolean;
}>`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    ${({ isMobileCardsLayout, showCarMoneyMonthlyPrice }) =>
        isMobileCardsLayout &&
        showCarMoneyMonthlyPrice &&
        css`
            margin-top: ${gutterSizes.medium};

            ${showCarMoneyMonthlyPrice &&
            css`
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                gap: ${gutterSizes.small};
            `}
        `}
`;

export const HeaderPriceBlock = styled.span<{ showCarMoneyMonthlyPrice: boolean }>`
    ${({ showCarMoneyMonthlyPrice }) =>
        showCarMoneyMonthlyPrice &&
        css`
            margin-top: ${gutterSizes.base};
        `}
`;

export const CarMoneyMonthlyPrice = styled.div`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.small};

    a {
        font-size: inherit;
        font-weight: ${fontWeights.normal};
    }
`;

export const ContactNameLocation = styled.div`
    display: inline-flex;
    margin: 0 0 ${gutterSizes.medium} 0;
    align-items: center;
`;

export const HeaderAddressBlock = styled.span<{
    isMobileCardsLayout: boolean;
    showCursor?: boolean;
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colorVariables.textLink};

    ${({ showCursor }) =>
        showCursor &&
        css`
            cursor: pointer;
        `}
`;

export const VatInfo = styled.div`
    display: inline-block;
    font-size: 12px;
    padding-left: 4px;
`;

export const VipTitle = styled.h1`
    margin: 0;

    ${mediaQuery.from(breakpoints.large)} {
        font-size: 24px;
    }
`;

export const VipAddress = styled.h4<{ isMobileCardsLayout: boolean; isSellerCinchCar: boolean }>`
    margin: 0 0 ${gutterSizes.medium} 0;
    font-weight: 500;
    line-height: 22px;
    font-size: ${fontSizes.base};

    ${(props) =>
        props.isSellerCinchCar &&
        css`
            padding-right: ${gutterSizes.large};
        `}

    &[data-q="ad-location"] {
        color: ${colorVariables.textLink};
    }

    ${(props) =>
        props.isMobileCardsLayout &&
        css`
            margin: 0;
        `}
`;

export const VipPrice = styled.h3<{ isMobileCardsLayout: boolean }>`
    font-size: ${fontSizes.xlarge};
    line-height: 28px;
    display: inline-block;

    ${mediaQuery.from(breakpoints.large)} {
        font-size: ${fontSizes.pgLarge};
    }

    ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout &&
        css`
            margin: 0;
            color: ${colors.green} !important;
        `}
`;
